import { render, staticRenderFns } from "./CmgSustainabilityInfoCard.vue?vue&type=template&id=7c8a962c&scoped=true&lang=pug"
import script from "./cmg-sustainability-info-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-sustainability-info-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgSustainabilityInfoCard.vue?vue&type=style&index=0&id=7c8a962c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8a962c",
  null
  
)

export default component.exports